<template>
  <div class="flex flex-col w-full gap-2.5 max-depx-2">
    <!-- Online users skeleton -->
    <div
      class="flex items-center justify-center w-full pt-4 max-large-desktop:hidden"
    >
      <ChatOnlineUsersSkeleton />
    </div>

    <!-- Chat rooms skeleton -->
    <ul v-for="index in count" :key="index">
      <ChatRoomButtonSkeleton :index="index" />
    </ul>
  </div>
</template>

<script setup lang="ts">
import ChatOnlineUsersSkeleton from "./chat-online-users-skeleton.vue";
import ChatRoomButtonSkeleton from "./chat-room-button-skeleton.vue";

const _props = withDefaults(
  defineProps<{
    count?: number;
  }>(),
  {
    count: 3, // Default to showing 3 chat room skeletons
  },
);
</script>
